import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/orderings/paid-installment/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const paidInstallment = {
  get: apiPathFunc(pathBase),
} as const;
